export function formatBytes(bytes: number, decimals: number = 2) {
	if (bytes === 0) return '0 Bytes';

	const k = 1024;
	const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
	// calculate index of the size unit
	const i = Math.floor(Math.log(bytes) / Math.log(k));

	const result = (bytes / k ** i).toFixed(decimals);

	return `${result} ${sizes[i]}`;
}
